import { ChartOfAccountsValues } from './types';

export const CHART_OF_ACCOUNTS_VALUES: ChartOfAccountsValues = {
  name: null,
  description: null,
  corporateChartOfAccountId: null,
};
